module.exports = __webpack_public_path__ + "static/media/marker.c4611a67.png";